import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const map = useMapContext()
    const selectedNodes = map.useSelectedNodes()

    if (! map.data.patternRev) {
        return null
    }

    const {canAddNodeToIsrfOld, addNodeToIsrfOld} = map.commands
    const nodes = canAddNodeToIsrfOld(selectedNodes)

    return {
        disabled: 0 === nodes.length,
        key: 'add-node-to-isrf-old',
        label: '原版加入软件SPEC单',
        onClick: () => addNodeToIsrfOld(nodes),
    }
}
